"use strict";

var _classCallCheck = require("/home/astrid/git/javascript/gatsby_plugins_starter/gitrepos/gatsby-starter-mapbox-examples/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/astrid/git/javascript/gatsby_plugins_starter/gitrepos/gatsby-starter-mapbox-examples/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/createClass");

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var MapboxStyleSwitcherControl = /*#__PURE__*/function () {
  function MapboxStyleSwitcherControl(styles, defaultStyle) {
    _classCallCheck(this, MapboxStyleSwitcherControl);

    this.styles = styles || MapboxStyleSwitcherControl.DEFAULT_STYLES;
    this.defaultStyle = defaultStyle || MapboxStyleSwitcherControl.DEFAULT_STYLE;
    this.onDocumentClick = this.onDocumentClick.bind(this);
  }

  _createClass(MapboxStyleSwitcherControl, [{
    key: "getDefaultPosition",
    value: function getDefaultPosition() {
      var defaultPosition = "top-right";
      return defaultPosition;
    }
  }, {
    key: "onAdd",
    value: function onAdd(map) {
      var _this = this;

      this.map = map;
      this.controlContainer = document.createElement("div");
      this.controlContainer.classList.add("mapboxgl-ctrl");
      this.controlContainer.classList.add("mapboxgl-ctrl-group");
      this.mapStyleContainer = document.createElement("div");
      this.styleButton = document.createElement("button");
      this.styleButton.type = "button";
      this.mapStyleContainer.classList.add("mapboxgl-style-list");

      var _iterator = _createForOfIteratorHelper(this.styles),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var style = _step.value;
          var styleElement = document.createElement("button");
          styleElement.type = "button";
          styleElement.innerText = style.title;
          styleElement.classList.add(style.title.replace(/[^a-z0-9-]/gi, '_'));
          styleElement.dataset.uri = JSON.stringify(style.uri);
          styleElement.addEventListener("click", function (event) {
            var srcElement = event.srcElement;

            if (srcElement.classList.contains("active")) {
              return;
            }

            _this.map.setStyle(JSON.parse(srcElement.dataset.uri));

            _this.mapStyleContainer.style.display = "none";
            _this.styleButton.style.display = "block";

            var elms = _this.mapStyleContainer.getElementsByClassName("active");

            while (elms[0]) {
              elms[0].classList.remove("active");
            }

            srcElement.classList.add("active");
          });

          if (style.title === this.defaultStyle) {
            styleElement.classList.add("active");
          }

          this.mapStyleContainer.appendChild(styleElement);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      this.styleButton.classList.add("mapboxgl-ctrl-icon");
      this.styleButton.classList.add("mapboxgl-style-switcher");
      this.styleButton.addEventListener("click", function () {
        _this.styleButton.style.display = "none";
        _this.mapStyleContainer.style.display = "block";
      });
      document.addEventListener("click", this.onDocumentClick);
      this.controlContainer.appendChild(this.styleButton);
      this.controlContainer.appendChild(this.mapStyleContainer);
      return this.controlContainer;
    }
  }, {
    key: "onRemove",
    value: function onRemove() {
      if (!this.controlContainer || !this.controlContainer.parentNode || !this.map || !this.styleButton) {
        return;
      }

      this.styleButton.removeEventListener("click", this.onDocumentClick);
      this.controlContainer.parentNode.removeChild(this.controlContainer);
      document.removeEventListener("click", this.onDocumentClick);
      this.map = undefined;
    }
  }, {
    key: "onDocumentClick",
    value: function onDocumentClick(event) {
      if (this.controlContainer && !this.controlContainer.contains(event.target) && this.mapStyleContainer && this.styleButton) {
        this.mapStyleContainer.style.display = "none";
        this.styleButton.style.display = "block";
      }
    }
  }]);

  return MapboxStyleSwitcherControl;
}();

MapboxStyleSwitcherControl.DEFAULT_STYLE = "Streets";
MapboxStyleSwitcherControl.DEFAULT_STYLES = [{
  title: "Dark",
  uri: "mapbox://styles/mapbox/dark-v10"
}, {
  title: "Light",
  uri: "mapbox://styles/mapbox/light-v10"
}, {
  title: "Outdoors",
  uri: "mapbox://styles/mapbox/outdoors-v11"
}, {
  title: "Satellite",
  uri: "mapbox://styles/mapbox/satellite-streets-v11"
}, {
  title: "Streets",
  uri: "mapbox://styles/mapbox/streets-v11"
}];
exports.MapboxStyleSwitcherControl = MapboxStyleSwitcherControl;